module.exports = __webpack_public_path__ + "static/media/flag-so.a213c3a8.webp";